import { getOffset } from 'common/utils/boxPosition';

export function scrollToElement(element, offsetTop = 0, duration = 500) {
    return new Promise(resolve => {
        $('html, body').animate(
            {
                scrollTop: getOffset(element).top - offsetTop,
            },
            duration,
            resolve
        );
    });
}

export function scrollDownToElement(element, offsetTop = 0, duration = 500) {
    if (isElementAboveDocumentScrollTop(element, offsetTop)) {
        scrollToElement(element, offsetTop, duration);
    }
}

function isElementAboveDocumentScrollTop(element, offsetTop) {
    const documentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    return getOffset(element).top - offsetTop - documentScrollTop >= 0;
}



// WEBPACK FOOTER //
// ./js/common/utils/scroll.js